import Index from '../../views/logs/Index.vue';

export default [
  {
    path: '/logs',
    name: 'logs',
    component: Index,
    meta: {
      can: 'view log',
      breadcrumb: [
        { name: '查證紀錄', route: "logs" }
      ]
    }
  },
]
